import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { DtoFranchiseListQueries } from '@/Interfaces/Dto';
import { stringifyQueryString } from '@/Utils/FnUtils';
import type { Franchise } from '@/Interfaces/Data';
import { apiClient } from '@/_config/lib/axios/api-client';

export const GET_FARES = 'GET_FARES';

type GetFaresData = {
  data: Franchise[];
  totalCount: number;
  r: boolean;
};

const getFares = (queries: DtoFranchiseListQueries) => {
  return apiClient
    .get<GetFaresData>(`/municipios/paginate?${stringifyQueryString(queries)}`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetFaresResponseType = Awaited<ReturnType<typeof getFares>>;

export const useGetFares = (
  queries: DtoFranchiseListQueries,
  options?: Omit<
    UseQueryOptions<
      GetFaresResponseType,
      unknown,
      GetFaresResponseType,
      (string | DtoFranchiseListQueries)[]
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: [GET_FARES, queries],
    queryFn: () => getFares(queries),
    staleTime: Infinity,
    ...options,
  });
};
